import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import { useCookies } from 'react-cookie';
import { brand } from '../theme';

const settings = ['Account', 'Logout'];

export interface ResponsiveAppBarProps {
  avatarLink: string;
  avatarAltText: string;
}

const ResponsiveAppBar = (props: ResponsiveAppBarProps) => {
  const [_, removeCookie] = useCookies(['jolly']);

  const handleRemoveCookie = () => {
    removeCookie('jolly', { path: '/' });
    window.location.replace('/login');
  };
  const { avatarAltText, avatarLink } = props;

  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <AppBar
      // White, as the storefront's header is: Pineapple's wordmark is black
      // and is drawn on white, and the green sidebar carries the colour.
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        bgcolor: '#ffffff',
        color: brand.ink,
        borderBottom: `1px solid ${brand.rule}`,
      }}
      position="fixed"
      elevation={0}
    >
      <Container maxWidth={false}>
        <Toolbar disableGutters>
          <Box
            component="img"
            src="/pineapple-logo.png"
            alt="Pineapple Net"
            // Cropped to its ink, so this is the wordmark's real height.
            sx={{
              height: 26, width: 'auto', mr: 2, display: 'block',
            }}
          />
          <Typography
            variant="subtitle1"
            component="span"
            sx={{
              flexGrow: 1,
              fontWeight: 600,
              color: 'text.secondary',
              borderLeft: `1px solid ${brand.rule}`,
              pl: 2,
            }}
          >
            Admin Portal
          </Typography>

          <Box sx={{ flexGrow: 0 }}>
            <Tooltip title="Open settings">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Avatar alt={avatarAltText} src={avatarLink} />
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: '45px' }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {settings.map((setting) => (
                <MenuItem key={setting} onClick={setting === 'Logout' ? handleRemoveCookie : handleCloseUserMenu}>
                  <Typography textAlign="center">{setting}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};
export default ResponsiveAppBar;
